// removed by extract-text-webpack-plugin
module.exports = {"button":"button__button___1EbNH","button__inner":"button__button__inner___1hiP6","button__icon":"button__button__icon___sLLuj","button--secondary":"button__button--secondary___wUlJz"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Button/button.scss
// module id = 117
// module chunks = 0